module.exports = {"210922100":"彰武镇","210922101":"哈尔套镇","210922102":"章古台镇","210922103":"五峰镇","210922104":"冯家镇","210922105":"后新秋镇","210922106":"东六家子镇","210922107":"阿尔乡镇","210922108":"前福兴地镇","210922109":"双庙镇","210922110":"大四家子镇","210922111":"苇子沟镇","210922112":"兴隆山镇","210922113":"满堂红镇","210922114":"四合城镇","210922115":"大冷蒙古族镇","210922116":"两家子镇","210922117":"平安镇","210922118":"四堡子镇","210922119":"西六家子镇","210922120":"大德镇","210922121":"兴隆堡镇","210922202":"二道河子蒙古族乡","210922209":"丰田乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210922.json
// module id = 570
// module chunks = 0